<template>
    <div>
        <el-card>
            <div slot="header" class="clearfix" style="text-align:center;">
                <span style="line-height: 36px;" >画廊编辑</span>

            </div>
            <div class="card-body" style="text-align:left;">
                <div class="item-list">

                  <p>
                      <span class="span_1">画廊列表</span>

                      <el-upload
                          ref="upload"
                          class="upload-demo"
                          action="http://upload.qiniu.com/"
                          :data="myForm"
                          method="post"
                          :on-preview="handlePreview"
                          :show-file-list="false"
                          :before-upload="handleBeforeUpload"
                          :on-success="handleSuccess"
                          :multiple="isMultiple"
                          :file-list="fileList1">
                          <el-button size="small" type="primary" >添加画廊</el-button>
                      </el-upload>


                     <div v-if="gallerys.length >0" style="margin-left:250px;">

                        <div v-for="(image,key) in gallerys" v-if="image!=''" style="display: inline;width: 200px;">

                           <img :src="image" @click='delImage(key)' style="width:200px;"/>
                           <a href="#" style="position: absolute; margin-left:-30px;margin-top:10px; color:#000;" @click='delImage(key)' >
                              <span class="el-icon-close"></span>
                          </a>
                        </div>
                    </div>


                  </p>


                </div>


                <div style="text-align: center">
                    <el-button class="item-right" type="info" :loading="btnLogin" @click="btnSave()">保存</el-button>
                </div>
            </div>
        </el-card>
    </div>
</template>


<script>

import $ajax from '../../https/config'
import {getQueryString, isNull} from '../../js/tool'

export default {
  data () {
    return {
      btnLogin:false,
      editFlag:0,
      bOnSale:true,
      isMultiple: true,
      fileList1: [],
      img1: '',
      form: {},
      gallerys:[]
    }
  },
  created: function () {
    //this.pageNo = 1
    this.getUpToken()
    this.queryFxGalleryList()
  },
  computed: {
    myForm: {
      set: function (value) {
        this.form = value
      },
      get: function () {
        return this.form
      }
    }
  },
  methods: {
    queryFxGalleryList () {

      var userInfoStr = sessionStorage.getItem('lbz-device-user-info')
      var userInfo =  JSON.parse(userInfoStr)

      var params = {
        owner :userInfo.owner
      }
      var _this = this
      $ajax.get('/ad/app/queryList', params, 'headers', function (res) {
        if (res && res.resultStatus === true) {
          //var resData = []
          if (res.resultData && res.resultData.length > 0) {
            _this.gallerys = res.resultData[0].icon.split(';');
          }
        } else {
        }
        _this.btnLogin = false
      })
    },
    getUpToken () {
      var myUrl =  'http://platform.songzb.com:32000/qiniuToken/image'
      var _this = this
      $ajax.get(myUrl, '', '', function (res) {
        _this.form.token = res.uptoken
      }, function () {
      })
    },
    handlePreview (file) {
    },
    handleBeforeUpload (file) {
      var last
      last = file.name.split('.').pop()
      if (last !== 'jpg' && last !== 'png' && last !== 'jpeg') {
        this.$message({
          type: 'error',
          message: '图片格式错误'
        })
        return false
      }
      var str = 'spgallery-' + (new Date().getTime()) + Math.ceil(Math.random() * 10) + '.' + last
      this.form.key = str
    },
    handleSuccess (response, file, fileList) {
        this.gallerys.push('http://image.songzb.com/' + response.key);
    },
    delImage (key){
      var _this = this;
      var tCommodityGallerys = [];
      for (var i=0; i<_this.gallerys.length; i++){

        if (key==i){

        }else{
          if (!isNull(_this.gallerys[i])){
            tCommodityGallerys.push(_this.gallerys[i]);
          }
        }
      }
      _this.gallerys = tCommodityGallerys;
    },
    btnSave: function () {
      var _this = this
      _this.btnLogin = true

      var params = {
        'icon' : _this.gallerys.join(";")
      }



      $ajax.post('/ad/gallery/update', params, 'headers', function (res) {
        if (res && res.resultStatus === true) {
          _this.$message({
            type: 'success',
            message: '保存画廊信息成功!'
          })
          setTimeout(function () {
            _this.btnLogin = false
            //_this.returnBack()
            //this.$router.go(0)
          }, 1000)
        } else {
          _this.$message({
            type: 'error',
            message: '保存画廊信息失败!' + res.errorMessage
          })
          _this.btnLogin = false
        }
      })
    },

  },
  components: {

  }
}
</script>

<style>
    .table_pagination {
      text-align: right;
      margin-top: 10px;
    }
    .upload-demo {

          margin-bottom:  10px;
          display: inline-block;
      }
      .span_1{
              display: inline-block;
              width: 250px;

            }
</style>



// WEBPACK FOOTER //
// src/page/fxshop/fxGallery.vue